export const walletConstant = {
    UDPATE_LOAD_WALLET: 'UDPATE_LOAD_WALLET',
    UPDATE_WALLET: 'UPDATE_WALLET',
    UPDATE_PROVIDER_WALLETS: 'UPDATE_PROVIDER_WALLETS',
    UPDATE_DEPOSIT_WITHDRAW_DECIMAL_SETTINGS: 'UPDATE_DEPOSIT_WITHDRAW_DECIMAL_SETTINGS',
    SET_WALLET_FETCH_STATUS: 'SET_WALLET_FETCH_STATUS',
    SET_PROVIDER_WALLETS_FETCH_STATUS: 'SET_PROVIDER_WALLETS_FETCH_STATUS',
    SET_CATEGORIZED_PROVIDER_WALLETS: 'SET_CATEGORIZED_PROVIDER_WALLETS',
};
